<template>
  <div class="manage">
    <div class="manage_title">订单权限</div>
    <div>
      <el-radio-group
        v-model="orderPermission"
        class="order-auth-radio"
        @change="saveOrderPermission"
      >
        <el-radio label="161">不限制</el-radio>
        <el-radio label="162">
          <div class="radio-with-tip">
            按组织机构限制
            <eui-tooltip
              style="margin-left: 10px"
              class="item"
              effect="dark"
              placement="top-start"
              content="员工只可查看和操作员工所属组织机构及下级组织机构员工提交的订单;管理员可查看和操作所有订单"
            >
            </eui-tooltip>
          </div>
        </el-radio>
        <el-radio label="163">
          <div class="radio-with-tip">
            按下单人限制
            <eui-tooltip
              style="margin-left: 10px"
              class="item"
              effect="dark"
              placement="top-start"
              content="员工只可查看和操作员工本人提交的订单;管理员可查看和操作所有订单"
            >
            </eui-tooltip>
          </div>
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import userApi from '../../api/user';

export default {
  name: 'OrderAuth',
  data() {
    return {
      orderPermission: '161',
    };
  },
  mounted() {
    this.queryOrderPermission();
  },
  methods: {
    // 订单权限查询
    async queryOrderPermission() {
      await userApi.queryOrderDataRightConfig().then((res) => {
        if (res.success) {
          const configData = Object.keys(res.data);
          if (configData.length > 0) {
            this.orderPermission = res.data.data;
          }
        }
      });
    },
    // 订单权限设置
    async saveOrderPermission() {
      await userApi
        .saveOrderDataRightConfig({ data: this.orderPermission })
        .then((res) => {
          if (res.success) {
            this.$message.success('订单权限设置成功！');
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.manage {
  background: #fff;
  padding: 0 20px 20px 20px;
  margin-bottom: 20px;

  .manage_title {
    font-size: 14px;
    line-height: 40px;
  }

  .radio-with-tip {
    display: inline-flex;
    align-items: center;
  }

  .tip-icon {
    margin-left: -6px;
    margin-right: 20px;
    color: #909399;
    cursor: pointer;
  }
}
</style>
